module.exports = __webpack_public_path__ + "img/brevicoryne-brassicae.69e4dd61.jpg";